import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../constants/request'
import { isRemoveAllEntityActionType } from '../../../../Entity'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../../Formik'
import {
  getRequestEditCategoryModalInitialValues,
  RequestEditCategoryModal,
} from '../../../../Request'
import { RequestEditPipelineModal } from '../../../RequestEditPipelineModal'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import {
  getRequestProfileHeaderEditCategoryPayload,
  getRequestProfileHeaderInfoItemsEditCategoryActionTypes,
} from '../useRequestProfileHeaderInfoItems'

import { getRequestProfileHeaderEditCategoryValidationSchema } from './useRequestProfileHeaderEditCategory.utils'

export function useRequestProfileHeaderEditCategory({
  handleCloseModal,
  handleReloadRequestPhases,
  handleUpdateEntity,
  requestData,
  setModal,
  onReloadArchivedPipelinesCount,
}) {
  const { handleReloadAfterChange } = useRequestProfileContext()

  const editCategoryInitialValues = getRequestEditCategoryModalInitialValues(
    requestData?.category
  )

  const editCategoryValidationSchema =
    getRequestProfileHeaderEditCategoryValidationSchema(
      editCategoryInitialValues
    )

  async function handleEditPipelineSubmit({
    isSwitchPipeline,
    payload: updatePayload,
  }) {
    await handleUpdateEntity(updatePayload)

    if (isSwitchPipeline) {
      onReloadArchivedPipelinesCount?.()
      handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.pipeline)
    } else {
      handleReloadRequestPhases()
    }

    handleCloseModal()
  }

  function handleEditCategorySubmit({ payload, values }) {
    if (
      isRemoveAllEntityActionType(
        values?.[FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]
      )
    ) {
      return handleUpdateEntity(payload)
        .then(() => handleReloadRequestPhases())
        .then(handleCloseModal)
    }

    setModal(
      <RequestEditPipelineModal
        categoryPayload={payload}
        onClose={handleCloseModal}
        onSubmit={handleEditPipelineSubmit}
      />
    )
  }

  function handleOpenEditCategoryModal() {
    setModal(
      <RequestEditCategoryModal
        formFieldsProps={{
          actionTypes:
            getRequestProfileHeaderInfoItemsEditCategoryActionTypes(),
        }}
        getPayload={getRequestProfileHeaderEditCategoryPayload}
        initialValues={editCategoryInitialValues}
        validationSchema={editCategoryValidationSchema}
        onClose={handleCloseModal}
        onSubmit={handleEditCategorySubmit}
      />
    )
  }

  return {
    handleOpenEditCategoryModal,
  }
}
